import type { LoadPlanningResponseDto } from '@/src/api/types/procurement'
import { CardHeader } from '@/src/components/shared/card/CardHeader'
import { isLoadPlanningDraft } from '@/src/features/procurement-and-markets/load-planning/load-planning-graph/LoadPlanning.utils'
import { appColors } from '@/src/theme'
import { Alert } from '@chakra-ui/react'
import { FlexCol } from '@components'
import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

interface LoadPlanningStatusIndicatorProps {
  loadPlanningData?: LoadPlanningResponseDto
}

const getColorMap = (isDraft: boolean) => {
  if (isDraft) {
    return {
      textColor: appColors.warning,
      bgColor: appColors.amber[50],
      borderColor: appColors.amber[50],
    }
  }

  return {
    textColor: appColors.positive,
    bgColor: appColors.green[100],
    borderColor: appColors.green[200],
  }
}

const getText = (isDraft: boolean, t: TFunction) => {
  if (isDraft) return t('components.procurement.forecasting.status_draft')

  return t('components.procurement.forecasting.status_saved')
}

export const LoadPlanningStatusIndicator = ({ loadPlanningData }: LoadPlanningStatusIndicatorProps) => {
  const { t } = useTranslation()

  if (!loadPlanningData) {
    return null
  }
  const isDraft = isLoadPlanningDraft(loadPlanningData)
  const colors = getColorMap(isDraft)

  return (
    <FlexCol gap={4}>
      <CardHeader textKey={'components.procurement.forecasting.status_header'} />
      <Alert
        bgColor={colors.bgColor}
        textColor={colors.textColor}
        borderRadius={'4px'}
        border={`1px solid ${colors.borderColor}`}
        py={'8px'}
        px={'12px'}
      >
        {getText(isDraft, t)}
      </Alert>
    </FlexCol>
  )
}
